export default __webpack_public_path__ + "static/media/riverbank-pizza.5ab4484f.jpg";